export default "__VITE_ASSET__DMFcBEs5__"